"use client";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { SERVICES } from "@/data/services-data";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ServiceSelectorGenerator({ value, handleMenuItemClick, data = SERVICES }) {
  const services = data;

  return (
    <Menu as="div" className="w-full relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex w-full justify-between items-center gap-x-1.5 rounded-xl bg-white px-4 py-3 text-base font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 transition-all">
          <span className="flex items-center gap-2">
            {value ? (
              <span>{value}</span>
            ) : (
              <span className="text-gray-500">Select Service</span>
            )}
          </span>
          <ChevronDownIcon
            className="h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="max-h-[50vh] h-auto overflow-y-scroll p-2 absolute left-0 z-50 mt-2 w-full origin-top-right rounded-2xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none will-change-transform">
          <div className="py-1">
            {services?.map((service, index) => (
              <Menu.Item key={index}>
                {({ active }) => (
                  <button
                    onClick={() => handleMenuItemClick(service)}
                    className={classNames(
                      active ? "bg-gray-100" : "",
                      "text-gray-700 block px-4 py-2 my-1 text-sm w-full text-left rounded-lg"
                    )}
                  >
                    {service.label}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
